import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabelText from '../LabelText';

const SubscribeEdm = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;
	const {fieldname, optin_text, required, show_label, title} = form_component;

	const fv = useSelector(state => state.fv);
	const userData = useSelector(state => state.userData);
	const shouldShowLabelByFlag = (show_label === true || show_label === 1 || show_label === '1' || show_label === 'true');
	const labelFormComponent = {
		...form_component,
		label: form_component.label || title || '',
		sub_label: form_component.sub_label || ''
	};
	const shouldShowLabel = shouldShowLabelByFlag || Boolean((labelFormComponent.label || '').trim());

	useEffect(() => { // to be updated after render
		if (fv && required) {
			fv.addField(fieldname, {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			});
		}
	}, [fv]);

	return (
		<div className={`flex-grow-1 t-and-c form-group ${required ? 'required' : ''}`}>
			{shouldShowLabel && (
				<LabelText
					form_component={labelFormComponent}
				/>
			)}
			<div className="form-check">
				<input
					type="checkbox"
					name={fieldname}
					id={fieldname}
					className="form-check-input"
				/>
				<label 
					htmlFor={fieldname}
					className="form-check-label xt_area"
					dangerouslySetInnerHTML={{__html: optin_text}}
				/>
			</div>
		</div>
	);
}

export default SubscribeEdm;